import React from 'react';

const isTeamGuide = process.env.REACT_APP_TEAMGUIDE === 'true';

interface TeamGuideProps {
  children: React.ReactNode;
}

const TeamGuide: React.FC<TeamGuideProps> = ({ children }) => {
  if (!isTeamGuide) return null;
  return <>{children}</>;
};

export default TeamGuide;
